(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["compatible-bikes"] && !Shopify.designMode) return;
  try {
    class CompatibleBikesTabs extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-cb-tab]').forEach(btn => {
        btn.addEventListener('click', () => this._switchTab(btn));
      });
    }
    _switchTab(activeBtn) {
      const target = activeBtn.getAttribute('data-cb-tab');
      this.querySelectorAll('[data-cb-tab]').forEach(btn => {
        const isActive = btn === activeBtn;
        btn.classList.toggle('cb-tab--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.querySelectorAll('.cb-panel').forEach(panel => {
        panel.classList.toggle('cb-panel--hidden', panel.id !== this.id + '-' + target);
      });
    }
  }
  if (!customElements.get('compatible-bikes-tabs')) {
    customElements.define('compatible-bikes-tabs', CompatibleBikesTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
